import HeroSection from "./components/HeroSection";
import TimelineSection from "./components/TimelineSection";
import SpaceXSection from "./components/SpaceXSection";
import ContractsSection from "./components/ContractsSection";
import CalculatorSection from "./components/CalculatorSection";
import ReviewsSection from "./components/ReviewsSection";
import WhyInvestSection from "./components/WhyInvestSection";
import FundingSection from "./components/FundingSection";
import TechnologySection from "./components/TechnologySection";
import RoadmapSection from "./components/RoadmapSection";
import TokenSection from "./components/TokenSection";
import FooterSection from "./components/FooterSection";
import LiveFeed from "./components/LiveFeed";

export default function Home() {
  const scrollToContracts = () => {
    document.getElementById("contracts")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <main className="bg-[#050810] min-h-screen">
      <LiveFeed />
      <HeroSection onJoinClick={scrollToContracts} onWhitepaperClick={scrollToContracts} />
      <TimelineSection />
      <SpaceXSection />
      <div id="contracts">
        <ContractsSection />
      </div>
      <CalculatorSection />
      <ReviewsSection />
      <WhyInvestSection />
      <FundingSection />
      <TechnologySection />
      <RoadmapSection />
      <TokenSection />
      <FooterSection />
    </main>
  );
}
